import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const SurveyAnswerOptionActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

SurveyAnswerOptionActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

SurveyAnswerOptionActions.defaultProps = {
  basePath: '',
  data: {},
};

export default SurveyAnswerOptionActions;
